import nexusCrmTestReportMarkdown from '@/assets/Artifacts/nexus-crm-test-report.md?raw'
import { buildStepNarration } from './stepNarrationCopy.js'
import {
  WEBSITE_CRM_PHASE2_THREAD_TITLE,
} from './websiteCrmDemoContent.part01.js'
import { SITE_ROOT } from './websiteCrmDemoContent.part03.js'

export const WEBSITE_CRM_AI_LOG_STEPS_CRM_TEST = [
  {
    durationMs: 22400,
    actionName: 'Finished running command',
    arguments: {
      command: `cd ${SITE_ROOT} && npx playwright test tests/demo-user-checkout.spec.js`,
    },
    result: {
      log: 'Running 1 test…\n  ✅ demo user bulk RFQ checkout (8.4s)\n\n  1 passed',
      exitCode: 0,
    },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      '✅ Milestone — demo user checkout passed, RFQ flow works end-to-end',
      'sending a live CRM trigger via the Salesforce webhook',
      0,
    ),
  },
  {
    durationMs: 5200,
    actionName: 'Finished running command',
    arguments: {
      command: `curl -s -X POST https://demo-compute.dataobserve.io/api/v1/salesforce/leads \\
  -H 'Content-Type: application/json' \\
  -d '{"company":"Acme Corp","email":"demo.procurement@acmecorp.example","lead_source":"NexusB2B Website — RFQ Form","product_interest":"NX-7742-BULK","quantity":50}'`,
    },
    result: {
      log: '✅ {"status":"success","details":{"id":"58930100001234567"}}\n📡 Webhook trigger delivered (wh_8f3a2c)',
      exitCode: 0,
    },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      '✅ Milestone — CRM lead created and workflow trigger fired',
      'writing the CRM test report document',
      1,
    ),
  },
  {
    durationMs: 8400,
    actionName: 'Wrote file',
    arguments: {
      op: 'write',
      path: `${SITE_ROOT}/nexus-crm-test-report.md`,
      content: nexusCrmTestReportMarkdown,
    },
    result: { ok: true },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'The demo-user and CRM trigger test report is saved',
      'updating the chat title',
      2,
    ),
  },
  {
    durationMs: 400,
    actionName: 'Chat renamed.',
    arguments: {
      toolName: 'rename_chat',
      args: { new_title: WEBSITE_CRM_PHASE2_THREAD_TITLE },
    },
    result: { message: `Chat renamed to: "${WEBSITE_CRM_PHASE2_THREAD_TITLE}"` },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      `This chat is now titled ${WEBSITE_CRM_PHASE2_THREAD_TITLE}`,
      'summarizing the CRM integration and test results',
      0,
    ),
  },
]

/** Phase 1 website build steps (stream + seed). */
